import { bindActionCreators } from "redux";
import { Action, ORDERS_UPLOADED, ORDERS_CHECKED } from ".";
import store from "./../reducers";

export default bindActionCreators({
	getOrders: () => Action(ORDERS_UPLOADED),
	checkOrders: (email, checked) => Action(ORDERS_CHECKED, { email, checked }),
}, store.dispatch);


// WEBPACK FOOTER //
// ./src/actions/order.js